import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useInventoryFilter } from "@/lib/inventory-filter";
import { useScopedNavigate } from "@/lib/scoped-nav";
import { useRole } from "@/lib/roles";
import { tabToPerspective, defaultPerspective } from "@/lib/perspectives";

export const Route = createFileRoute("/buildings/$buildingId")({
  component: BuildingDetailRedirect,
});

// The building-detail page is retired — every building surface lives in a perspective now, entered
// by setting building scope. This route survives only to honour old links: it sets scope for the
// building and redirects to the perspective the requested `#tab` moved to (e.g. `#simulointi` →
// Strategia), or the role's default perspective for a bare `/buildings/$id`.
function BuildingDetailRedirect() {
  const { buildingId } = Route.useParams();
  const navigate = useScopedNavigate();
  const { setBuildingId } = useInventoryFilter();
  const { role } = useRole();

  useEffect(() => {
    setBuildingId(buildingId);
    const hash = window.location.hash.replace("#", "");
    const to = tabToPerspective[hash] ?? defaultPerspective[role];
    void navigate({ to, replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buildingId]);

  return <div className="p-6 text-muted-foreground">Ohjataan…</div>;
}
